import React, { useState } from 'react';
import { ScrollView, View } from 'react-native';
import { useQuery } from '@apollo/client';
import { dollars } from 'app/src/utils/stringHelpers';

import DataState from 'app/src/components/DataState';
import { useParams } from 'app/src/utils/routing';
import colors from 'app/src/styles/colors';

import BidHistory from './BidHistory';
import PriorLot from './PriorLot';

import {
  ContainerWithFlash,
  Container,
  BorderedContainer,
  ColumnContainer,
  Column,
  Title,
  LeftContainer,
  RightContainer,
  LotDetails,
  HudPrice,
  HudBidderDetailsContainer,
  HudBidderDetails,
  HudAssetDetailsContainer,
  HudAssetDetails,
  HudChoiceDetails,
  PreBidAlert
} from './elements';
import SaleAssetDetail from './SaleAssetDetail';
import { SALE } from './queries';
import { BIDDING_NOTICES } from './Notices/queries';
import useSubscriptions from './useSubscriptions';
import Header from './Header';

const foregroundColor = bidDetails => {
  return bidDetails?.backgroundColor ? bidDetails.foregroundColor : '#000';
};

const Hud = () => {
  const { id } = useParams();

  useSubscriptions({ id });

  const { data } = useQuery(SALE, { variables: { id } });

  if (!data) { return <DataState.Loading />; }

  const biddingSaleAsset = data.sale.biddingSaleAsset;
  const highBidDetails = biddingSaleAsset?.bids?.find(bid =>
    bid.price === biddingSaleAsset.highBid && !bid.removedAt
  )

  let bidOwner = highBidDetails?.buyer ||
    highBidDetails?.paddleService || 'Floor'
  ;

  function formatBidOwner() {
    return (
      <HudBidderDetailsContainer>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <HudBidderDetails
            color={foregroundColor(highBidDetails)}
          >
            {
              `By: ${bidOwner === 'Floor' ? bidOwner : bidOwner.name || ''}`
            }
          </HudBidderDetails>
          {highBidDetails?.buyer ?
            <>
              <HudBidderDetails
                color={foregroundColor(highBidDetails)}
                style={{paddingTop: '0px'}}
              >
                {`${highBidDetails.buyer?.city}, ${highBidDetails.buyer?.state}`}
              </HudBidderDetails>
            </> :
            null
          }
        </View>
        {highBidDetails.paddleNumber ?
          <View style={{display: 'flex', flexDirection: 'column'}}>
            <HudBidderDetails
              color={foregroundColor(highBidDetails)}
            >
              Paddle Number:
            </HudBidderDetails>
            <HudBidderDetails
              color={foregroundColor(highBidDetails)}
              style={{paddingTop: '0px', alignSelf: 'flex-end'}}
            >
              {highBidDetails.paddleNumber}
            </HudBidderDetails>
          </View> :
          null
        }
      </HudBidderDetailsContainer>
    )
  }

  return (
    <ContainerWithFlash>
      <Container style={{minHeight: '93vh'}}>
        <Header sale={data.sale} />
        <ColumnContainer style={{width: '100%'}}>
          <Column style={{width: '25%'}}>
            {biddingSaleAsset ? (
              <SaleAssetDetail
                saleAsset={biddingSaleAsset}
                groupSaleAssets={data.sale.bidGroupSaleAssets}
                clerk
              />
            ) : (
              <BorderedContainer>
                <Title>No Assets Current Bidding</Title>
              </BorderedContainer>
            )}
            <PriorLot priorSaleAsset={data.sale.priorSaleAsset} />
          </Column>
          <Column
            style={{
              width: '75%',
              left: '25%'
            }}
          >
            <BorderedContainer
              style={{
                borderLeft: 'none',
                borderBottom: 'none',
                backgroundColor: colors.elGray
              }}
            >
              <LotDetails>
                {
                  biddingSaleAsset ?
                    `Current Lot: ${biddingSaleAsset?.lotNumber} ${biddingSaleAsset?.asset.name}` :
                    'No Assets Current Bidding'
                }
              </LotDetails>
            </BorderedContainer>
            <BorderedContainer
              style={{
                borderLeft: 'none',
                borderBottom: 'none',
                backgroundColor: highBidDetails?.backgroundColor,
                minHeight: biddingSaleAsset ? '52.2vh' : '32.1vh'
              }}
            >
              {
                parseInt(biddingSaleAsset?.highPreBid?.bidId) === parseInt(highBidDetails?.id) &&
                <PreBidAlert
                  style={{fontSize: '26px', fontWeight: 'bold'}}
                >
                  PRE-BID
                </PreBidAlert>
              }
              <HudPrice
                color={foregroundColor(highBidDetails)}
              >
                {!!highBidDetails ?
                  `${dollars(highBidDetails.price)}` :
                  'No Current Bid'
                }
              </HudPrice>
              {highBidDetails &&
                formatBidOwner()
              }
            </BorderedContainer>
            <BorderedContainer
              style={{
                borderLeftWidth: '0px',
                borderRightWidth: '3px',
                borderTopWidth: '0px',
                borderTop: biddingSaleAsset ? '' : 'none',
                padding: '0px',
                display: 'flex',
                flexDirection: 'row',

              }}
            >
              {biddingSaleAsset && (
                <LeftContainer style={{padding: '5px'}}>
                  <HudAssetDetailsContainer>
                    <HudAssetDetails
                      color={biddingSaleAsset.reservePrice ?
                        colors.biddingBrightRed :
                        '#000'
                      }
                    >
                      {biddingSaleAsset.reservePrice ?
                        `Reserve: ${dollars(biddingSaleAsset.reservePrice)}` :
                        'No Reserve'
                      }
                    </HudAssetDetails>
                    <HudAssetDetails>
                      {
                        biddingSaleAsset.asset.expectedYieldPrice &&
                        biddingSaleAsset.asset.expectedYieldPrice > 0 ?
                          `Expected Yield: ${dollars(biddingSaleAsset.asset.expectedYieldPrice)}` :
                          ''
                      }
                    </HudAssetDetails>
                  </HudAssetDetailsContainer>
                  {data.sale.bidGroupSaleAssets?.length ?
                    <BorderedContainer
                      style={{borderColor: 'blue', borderWidth: '6px'}}
                    >
                      <ScrollView>
                        <HudChoiceDetails style={{fontSize: '30px', fontWeight: 900}}>
                          This lot is part of a choice.
                        </HudChoiceDetails>
                        {/* <HudChoiceDetails style={{marginTop: '10px', marginBottom: '10px'}}>
                          Additional Lots:
                        </HudChoiceDetails> */}
                        {data.sale.bidGroupSaleAssets?.map(choiceAsset => {
                          // if(choiceAsset.id !== data.sale.biddingSaleAsset.id) {
                            return (
                              <HudChoiceDetails style={{fontWeight: 'bold', fontSize: '18px'}}>
                                {`${choiceAsset.lotNumber}`}
                                {`  `}
                                {`${choiceAsset.asset.name}`}
                              </HudChoiceDetails>
                            )
                          // }
                        })}
                      </ScrollView>
                    </BorderedContainer> :
                    null
                  }
                </LeftContainer>
              )}
              {biddingSaleAsset && (
                <RightContainer
                  style={{
                    paddingLeft: '5px',
                    paddingRight: '5px',
                    paddingTop: '10px',

                    borderLeftWidth: '3px',
                    minHeight: '33.65vh'
                  }}
                >
                  <BidHistory bids={biddingSaleAsset?.bids} />
                </RightContainer>
              )}
            </BorderedContainer>
          </Column>
        </ColumnContainer>
      </Container>
    </ContainerWithFlash>
  );
};

export default Hud;
